<template>
  <div class="page">
    <Header
      :setting="{
        title: '預約掛號',
        hasCancelMethod: true,
      }"
      @cancel="$emit('cancel')"
      class="mb4"
    />
    <div class="fc--primary mb4">
      {{ clinic.fullname }}
    </div>

    <div class="row--central mb3">
      <div class="label label--secondary fs1 mh2">
        {{ spiderman.moment(shift.date).format('MM/DD') }}
        ({{ spiderman.moment(shift.date).locale('zh_cn').format('dd') }})
      </div>
      <div class="label label--secondary fs1 mh2">
        {{ shift.division }}
      </div>
    </div>
    <Shift
      :shift="shift"
      :has-button="false"
    />
    <div class="page__form mv7">
      <template v-if="composable.member.info.status==='in'">
        <select
          v-model="identity"
          class="align--center mb4"
        >
          <option :value="composable.member.info.name">
            {{ composable.member.info.name }}
          </option>
          <template
            v-for="child in composable.member.info.children"
            :key="child"
          >
            <!-- //!僅顯示該院區的小孩 -->
            <option
              v-if="child.clinic===composable.member.info.clinic"
              :value="child.name"
            >
              {{ child.name }}
            </option>
          </template>
          <option :value="''">
            自行輸入
          </option>
        </select>
      </template>
      <input
        v-if="identity===''"
        type="text"
        placeholder="真實姓名/Real Name"
        v-model="memberInfo.name"
        class="mb4"
      >
      <input
        type="text"
        placeholder="身份證/Resident ID No."
        v-model.trim="memberInfo.id"
        class="mb4"
      >
      <input
        type="text"
        placeholder="西元生日/Birth Date(YYYYMMDD)"
        v-model.trim="memberInfo.birthdate"
        class="mb4"
      >
      <input
        type="text"
        placeholder="手機號碼/Mobile"
        v-model.trim="memberInfo.mobile"
        class="mb4"
      >
      <select
        v-model="selectedNote"
        class="align--center mb4"
      >
        <option :value="''">
          請選擇看診目的
        </option>
        <template
          v-for="note in notes"
          :key="note"
        >
          <option :value="note">
            {{ note }}
          </option>
        </template>
      </select>
    </div>
    <div
      @click="$emit('makeAppointment')"
      class="label label--primary mb4"
    >
      確認預約
    </div>
    <div
      @click="$emit('clearMemberInfo')"
      class="label label--secondary mb4"
    >
      清除預約資訊
    </div>
    <div
      @click="$emit('cancel')"
      class="label label--secondary"
    >
      取消返回
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import Shift from '../components/Shift.vue';

export default {
  components: { Shift },
  props: {
    clinic: {
      type: Object,
      default() {
        return {};
      },
    },
    shift: {
      type: Object,
      default() {
        return {};
      },
    },
    notes: {
      type: Object,
      default() {
        return {};
      },
    },
    modelMemberInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    modelIdentity: {
      type: String,
      default: '',
    },
    modelSelectedNote: {
      type: String,
      default: '',
    },
  },
  emits: [
    'cancel',
    'update:modelMemberInfo',
    'update:modelIdentity',
    'update:modelSelectedNote',
    'clearMemberInfo',
    'makeAppointment',
  ],
  setup(props, { emit }) {
    const memberInfo = computed({
      get: () => props.modelMemberInfo,
      set: (value) => emit('update:modelMemberInfo', value),
    });

    const identity = computed({
      get: () => props.modelIdentity,
      set: (value) => emit('update:modelIdentity', value),
    });

    const selectedNote = computed({
      get: () => props.modelSelectedNote,
      set: (value) => emit('update:modelSelectedNote', value),
    });

    return {
      composable,
      spiderman,
      identity,
      memberInfo,
      selectedNote,
    };
  },
};
</script>
